<template>
  <div>
    <SectionOne
      id="section1"
      :values="application.section1"
      :onValueChanged="onValueChanged"
      :missingInfo="error && error.length > 0"
      :emailDisclaimerShown="emailDisclaimerShown"
      :showEmailDisclaimer="showEmailDisclaimer"
    />
    <SectionTwo
      :values="application.section2"
      :onValueChanged="onValueChanged"
    />
    <SectionThree
      :values="application.section3"
      :onValueChanged="onValueChanged"
      :addAdditionalSection="
        application.canAddAdditionalSectionThree
          ? addAdditionalSectionThree
          : null
      "
    />
    <div v-if="application.section3_1" class="container mt-5">
      <div class="jumbotron">
        <div class="container">
          <SectionThree
            :values="application.section3_1"
            :onValueChanged="onValueChanged"
            :extraSectionIndex="1"
            :removeSection="removeSectionThree"
          />
        </div>
      </div>
    </div>
    <div v-if="application.section3_2" class="container mt-5">
      <div class="jumbotron">
        <div class="container">
          <SectionThree
            :values="application.section3_2"
            :onValueChanged="onValueChanged"
            :extraSectionIndex="2"
          />
        </div>
      </div>
    </div>
    <div v-if="application.section3_3" class="container mt-5">
      <div class="jumbotron">
        <div class="container">
          <SectionThree
            :values="application.section3_3"
            :onValueChanged="onValueChanged"
            :extraSectionIndex="3"
          />
        </div>
      </div>
    </div>
    <SectionFour
      :values="application.section4"
      :onValueChanged="onValueChanged"
      :addAdditionalSection="
        application.canAddAdditionalSectionFour
          ? addAdditionalSectionFour
          : null
      "
    />
    <div v-if="application.section4_1" class="container mt-5">
      <div class="jumbotron">
        <div class="container">
          <SectionFour
            :values="application.section4_1"
            :onValueChanged="onValueChanged"
            :extraSectionIndex="1"
            :removeSection="removeSectionFour"
          />
        </div>
      </div>
    </div>
    <div v-if="application.section4_2" class="container mt-5">
      <div class="jumbotron">
        <div class="container">
          <SectionFour
            :values="application.section4_2"
            :onValueChanged="onValueChanged"
            :extraSectionIndex="2"
            :removeSection="removeSectionFour"
          />
        </div>
      </div>
    </div>
    <div v-if="application.section4_3" class="container mt-5">
      <div class="jumbotron">
        <div class="container">
          <SectionFour
            :values="application.section4_3"
            :onValueChanged="onValueChanged"
            :extraSectionIndex="3"
            :removeSection="removeSectionFour"
          />
        </div>
      </div>
    </div>
    <SectionFive
      :values="application.section5"
      :onValueChanged="onValueChanged"
    />
    <SectionExtra
      :values="application.extra"
      :onValueChanged="onValueChanged"
      :addAdditionalImage="
        application.canAddAdditionalImage ? addAdditionalImage : null
      "
      :removeAdditionalImage="removeAdditionalImage"
      :allowImages="allowImages"
    />
  </div>
</template>

<script>
import SectionOne from "@/components/Application/SectionOne";
import SectionTwo from "@/components/Application/SectionTwo";
import SectionThree from "@/components/Application/SectionThree";
import SectionFour from "@/components/Application/SectionFour";
import SectionFive from "@/components/Application/SectionFive";
import SectionExtra from "@/components/Application/SectionExtra";
import { Application } from "@/typings/application";

export default {
  name: "applicationForm",
  components: {
    SectionOne,
    SectionTwo,
    SectionThree,
    SectionFour,
    SectionFive,
    SectionExtra
  },
  props: {
    application: {
      type: Application,
      required: true,
      default: () => {
        return new Application();
      }
    },
    error: {
      type: String,
      required: false,
      default: () => {
        return null;
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSectionThree: {
      type: Function,
      required: true,
      default: () => {}
    },
    removeSectionThree: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSectionFour: {
      type: Function,
      required: true,
      default: () => {}
    },
    removeSectionFour: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalImage: {
      type: Function,
      required: false,
      default: () => {}
    },
    removeAdditionalImage: {
      type: Function,
      required: false,
      default: () => {}
    },
    allowImages: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      }
    },
    emailDisclaimerShown: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      }
    },
    showEmailDisclaimer: {
      type: Function,
      required: false,
      default: () => {}
    }
  }
};
</script>

<style></style>
